/**
 * @packageDocumentation
 * @module f1/string
 */

export interface Uncapitalize {
  /**
   * Remove a capitalization
   *
   * @public
   * @function f1.uncapitalize
   * @param s any string
   * @example
   *
   * ```ts
   * f1.uncapitalize('Mr. Jay Jones') === 'mr. Jay Jones'
   * ```
   */
  (s: string): string;
}

/**
 * @see Uncapitalize
 */
export default (s: string) => {
  return s.slice(0, 1).toLowerCase() + s.slice(1);
};
